import { Component } from '@angular/core';
import { defaultChartOptions } from '@vex/utils/default-chart-options';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { libservice } from 'src/app/lib/lib.service';

import { LoginService } from 'src/app/core/authentication';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { VexLayoutService } from '@vex/services/vex-layout.service';

@Component({
  selector: 'vex-mobilelayout',
  templateUrl: './mobilelayout.component.html',
  styleUrl: './mobilelayout.component.scss',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, CommonModule, RouterModule],
  providers: [libservice]
})
export class MobilelayoutComponent {
  data: any = [];
  dataArray: any = [28, 40, 36, 0, 52, 38, 60, 55, 99, 54, 38, 87];
  salesSeriesas: ApexAxisChartSeries = [
    {
      name: 'Sales',
      data: []
    }
  ];
  userdata: any = JSON.parse(localStorage.getItem('userData') || '{}');

  companylist: any = this.loginservice.getCompanyInfo();
  // JSON.parse(localStorage.getItem('companylist') || '{}');
  dataform = this.fb.group({
    mob: [JSON.parse(localStorage.getItem('mob') || '{}').mob, Validators.required],
    cid: [],
    id: [this.userdata?.id],
    accid: [this.userdata?.id],
    siblingid: [this.userdata?.siblingid],
    reptype: [1],
    gid: [],
    fdt: [new Date(2025, 3, 1)],
    tdt: [new Date()]
  });
  cmpnm: any = '';
  propercase(val: string) {
    return val.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  constructor(
    private fb: FormBuilder,
    private readonly layoutService: VexLayoutService,
    private libservice: libservice,
    private router: Router,
    private loginservice: LoginService
  ) {
    //  let cinfo: any = this.loginservice.getCompanyInfo();
    // this.cmpnm = this.propercase(cinfo.cname);
    // this.libservice.mobilemastersummary(this.dataform.value).subscribe((res: any) => {
    //   this.carddata = res.data;
    // });
    // const now = new Date();
    // const firstDateOfMonth = moment(new Date(now.getFullYear(), now.getMonth(), 1)).format('YYYY-MM-DD');
    // let postdata = { id: this.loginservice.getUserData().id, roleid: this.loginservice.getUserData().roleid, zoneid: this.loginservice.getUserData().zoneid, excid: this.loginservice.getUserData().excid, fdt: firstDateOfMonth, tdt: moment(new Date()).format('YYYY-MM-DD') };
    // this.libservice.dashboard(postdata).subscribe((res: any) => {
    //   this.data = res.data;
    //   this.convertToArray();
    // });
  }
  cardclick(event: any) {
    if (event == 'Total Sales') {
      this.router.navigateByUrl('/reportregister/salesregister');
    }
    if (event == 'Total Order') {
      this.router.navigateByUrl('/reportregister/salesorderregister');
    }
    if (event == 'Receipt') {
      this.router.navigateByUrl('/reportregister/receipt');
    }
    if (event == 'Outstanding') {
      this.router.navigateByUrl('/displayreport/outstanding');
    }
    if (event == 'Total Production') {
      this.router.navigateByUrl('/stockreport/productionlist');
    }
  }
  convertToArray() {
    this.dataArray = this.data[1][0].salesgraph.split(',').map(Number);
    this.salesSeriesas[0].data = this.dataArray;
  }
  carddata: any = [
    // { id: 11, nm: 'Share', bal: 435, grno: 'asd', imageUrl: './../../../../assets/img/pic/credit_4334700.png', roundimg: true, router: '/displayreport/ledger', ltype: '' },
    // { id: 1332, nm: 'CDS', bal: 435, grno: 'asd', imageUrl: './../../../../assets/img/pic/credit_4334700.png', router: '/displayreport/daybook' },
  ];
  cardssclick(event: any) {
    this.dataform.get('gid')?.setValue(event.gid);
    if ((event.natid == 49 || event.natid == 48) && !event.led_no) {
      this.dataform.get('reptype')?.setValue(2);

      //   this.libservice.mobilemastersummary(this.dataform.value).subscribe((res: any) => {
      //     this.carddata = res.data;
      //     this.dataform.get('reptype')?.setValue(1);
      //     if (event.natid == 48) {
      //       this.dataform.get('reptype')?.setValue(3);

      //       this.dataform.get('accid')?.setValue(res.data[0].id);
      //       this.libservice.mobilemastersummary(this.dataform.value).subscribe((res: any) => {
      //         this.dataval.totbal = res.data.reduce((sum: any, item: any) => sum + (item.fd_amt || 0), 0);
      //         this.carddata = res.data;
      //         this.dataform.get('reptype')?.setValue(1);
      //       });
      //     } else {
      //       this.dataval.totbal = res.data.reduce((sum: any, item: any) => sum + (item.bal || 0), 0);
      //     }
      //   });
      // } else {
      //   this.dataform.get('reptype')?.setValue(2);

      //   this.libservice.mobilemastersummary(this.dataform.value).subscribe((res: any) => {
      //     this.dataform.get('reptype')?.setValue(1);
      //     if (event.led_no) {
      //       this.router.navigate(['/displayreport/ledger'], { queryParams: { id: event.id } });
      //     } else if (event.cert_no) {
      //     } else {
      //       this.router.navigate(['/displayreport/ledger'], { queryParams: { id: res.data[0].id } });
      //     }
      //   });
    }
    if (event.router) {
      this.router.navigate([event.router], { queryParams: { accid: event.id, type: event.type } });
    } else if (event.type == 'rd') {
      this.router.navigate(['/'], { queryParams: { type: event.type } });
    }
  }
  companyselect() {
    this.router.navigate(['/companyselect']);
  }
  transformval(value: number): number {
    return Math.abs(value);
  }
  icon = 'fa-ad';
  dataval: any = { nm: '', mem_no: 0, totbal: 0, credit: 0, desig: '' };
  ngOnInit() {
    // this.libservice.ledgerget({}).subscribe((res: any) => {
    // this.dataval = res.data[0]
    // this.carddata.forEach((el: any) => {
    //   if (el.id) {
    //   }
    // });
    // });
  }

  series: ApexAxisChartSeries = [
    {
      name: 'Subscribers',
      data: [28, 40, 36, 0, 52, 38, 60, 55, 67, 33, 89, 44]
    }
  ];

  userSessionsSeries: ApexAxisChartSeries = [
    {
      name: 'Users',
      data: [10, 50, 26, 50, 38, 60, 50, 25, 61, 80, 40, 60]
    },
    {
      name: 'Sessions',
      data: [5, 21, 42, 70, 41, 20, 35, 50, 10, 15, 30, 50]
    }
  ];

  salesSeries: ApexAxisChartSeries = [
    {
      name: 'Sales',
      data: [28, 40, 36, 0, 52, 38, 60, 55, 99, 54, 38, 87]
    }
  ];

  pageViewsSeries: ApexAxisChartSeries = [
    {
      name: 'Page Views',
      data: [405, 800, 200, 600, 105, 788, 600, 204]
    }
  ];

  uniqueUsersSeries: ApexAxisChartSeries = [
    {
      name: 'Unique Users',
      data: [356, 806, 600, 754, 432, 854, 555, 1004]
    }
  ];

  uniqueUsersOptions = defaultChartOptions({
    chart: {
      type: 'area',
      height: 100
    },
    colors: ['#ff9800']
  });
  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  logout() {
    // localStorage.removeItem('mob');
    this.router.navigate(['/mobilelogin']);
  }
}
